"use strict";

const { DateTime, Duration } = require("luxon");

const getNow = require("../utils/get-now");

/**
 * Get fixed dates
 */
const getDatesFromFixedMode = (props) => {
  const { startDate, endDate, timezone, offsetDates } = props;

  return {
    startDate: DateTime.fromISO(startDate, {
      zone: "Etc/UTC"
    }).setZone(timezone, { keepLocalTime: offsetDates }),
    endDate: DateTime.fromISO(endDate, { zone: "Etc/UTC" }).setZone(timezone, {
      keepLocalTime: offsetDates
    })
  };
};

/**
 * Get since dates
 */
const getDatesFromSinceMode = (props) => {
  const { startDate, timezone, offsetDates } = props;
  return {
    startDate: DateTime.fromISO(startDate, {
      zone: "Etc/UTC"
    }).setZone(timezone, { keepLocalTime: offsetDates }),
    endDate: getNow(props).setZone(timezone, { keepLocalTime: offsetDates })
  };
};

/**
 * Get single date
 */
const getDatesFromSingleMode = (props) => {
  const { singleDate, timezone, offsetDates } = props;

  const date = DateTime.fromISO(singleDate, {
    zone: "Etc/UTC"
  }).setZone(timezone, { keepLocalTime: offsetDates });

  return { startDate: date, endDate: date };
};

/**
 * Get rolling duration:
 * Sets the endDate to now.
 * Sets the startDate based on the duration and snapDates unit (e.g. P1M will set startDate to beginning of this month).
 */
const getDatesFromRollingMode = (props) => {
  const { dateDuration } = props;

  const now = getNow(props);
  const duration = Duration.fromISO(dateDuration);

  return {
    startDate: now.minus(duration),
    endDate: now
  };
};

/**
 * Get base dates:
 * Gets modified fixed dates, or from a rolling duration, based on the available date props.
 */
const getBaseDates = (result, props) => {
  const { mode } = props;

  switch (mode) {
    case "fixed":
      return getDatesFromFixedMode(props);
    case "since":
      return getDatesFromSinceMode(props);
    case "single":
      return getDatesFromSingleMode(props);
    case "rolling":
      return getDatesFromRollingMode(props);
  }
};

module.exports = getBaseDates;
